module.exports = __webpack_public_path__ + "202408221624/img/btn_banner.2a3c25b4.png";